import functions from "./functions.js";
import tplLoader from "./tpl-loader.js";

$(function () {

    const $form = $('.booking-form');
    const form = $form[0];

    if (!form) {
        return;
    }

    const booking = {
        $form: null,
        $payment: null,
        $calculation: null,
        calc: [],
        persons: null,
        promoDiscount: null,
        totalAmount: null,

        init() {
            booking.$form = $(".booking-form");
            booking.$calculation = $(".table-calculation");
            booking.promoDiscountItem = booking.$calculation.data('promodiscountitem');
            booking.$payment = $(".payment-details");
            booking.$pricingContainer = $(".booking-pricing-container");
            booking.params = {};

            $('.price-changed').on('click', function() {
                functions.isMobile() ? $(window).scrollTop($('.loader-parent').offset().top) : $(window).scrollTop($('body').offset().top);
            })

            booking.$form.find('#contact-name, #contact-surname, #contact-email, #contact-tel, #agree, #contact-addres').focusout( function(e) {
                let $elem = $(this);
                let valid = true;

                if ($elem.attr('name') == 'email')
                {
                    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                    valid = regex.test($elem.val());
                }

                if ( ! ($elem.val() && valid)) 
                {
                    $elem.addClass('input-empty');
                    $elem.siblings('.invalid-feedback').addClass('d-block');
                }
                else
                {
                    $elem.removeClass('input-empty');
                    $elem.siblings('.invalid-feedback').removeClass('d-block');
                }
            })

            $("*[data-calc]").each(function (index) {
                let item = JSON.parse($(this).attr('data-calc'));
                item.inCalc = item.isOptional ? 0 : 1;
                booking.calc.push(item);
            });

            $('.calc-item-row input[type="checkbox"]').change(function (e) {
                let $row = $(this).closest('.calc-item-row');
                let $quantity = $row.find('select.quantity');
                let value = +$quantity.val();
                let checked = $(this).is(':checked') ? 1 : 0;

                if (checked && !value) {
                    $quantity.prop('value', 1);
                } else if (!checked && value) {
                    $quantity.prop('value', 0);
                }

                booking.calculate($(this));
            });

            $('.allianz-row input[type="checkbox"]').change(function (e) {
                let $checkbox = $(this).find('input[type="checkbox"]');

                if ($checkbox.is(':checked')) $checkbox.prop('checked', true);
                booking.calcAllianz();
            });

            $('.calc-item-row select.quantity').change(function (e) {
                let $row = $(this).closest('tr');
                let $checkbox = $row.find('input[type="checkbox"]');
                let value = +$(this).val();

                if (value && !$checkbox.is(':checked')) {
                    $checkbox.prop('checked', true);
                } else if (!value && $checkbox.is(':checked')) {
                    $checkbox.prop('checked', false);
                }

                booking.calculate($(this));
            });

            booking.total();


            if (booking.$payment.length) {
                booking.params.paymentType = 'creditCard';
                $('input[name="paymentType"]').on('change', e => {
                    booking.params.paymentType = $('input[name="paymentType"]:checked').val();
                });
            }
            
            let guests = functions.getUrlData().guests;
            if(guests && $('.simple-guests')[0]) {
                $('.simple-guests').each( (index, elem) => {
                    elem._simpleGuests.setValue(guests);
                });
            }

            $(".btn-promo-code").on('click', e => {
                let params = {};
                params['language'] = functions.getLang();
                params['promoCode'] = $("input[name='promoCode']").val();

                $.post('/services/promoCode/', params).then(response => {
                    response = JSON.parse(response);

                    $(".promo-code-output").removeClass('d-none').html(response.data);
                    if (response.status == true) {
                        $(".btn-promo-code").attr('disabled', true);
                        booking.applyDiscount(response);
                    }
                });
            });

            $('[name="guests"]').on('change', e => {
                e.preventDefault();
                const $target = $(e.target);
                let guesetsVal = $target.val().split(',');
                let $guestsElem = $('.booking-guests');
                if (guesetsVal[0]) $guestsElem.find('.adults > .number').html(guesetsVal[0]);
                if (guesetsVal[1] != 0)
                {
                    $guestsElem.find('.children > .number').html(guesetsVal[1]);
                    $guestsElem.find('.children').removeClass('d-none');
                }
                else 
                {
                    $guestsElem.find('.children').addClass('d-none');
                }

                let params = functions.getUrlData(false);
                params.guests = $target.val();
                params.language = functions.getLang();

                // booking.setLoadingMode();
                let oldTotal = $('.total').html().replace(/\s/g, '');
                $.get('/services/booking_form/', $.param(params)).then(response => {
                    if (response.status) {
                        booking.calc = [];
                        booking.$pricingContainer.html(response.html);
                        let newTotal = booking.$pricingContainer.find('.total').html().replace(/\s/g, '');
                        $('.price-changed').toggleClass('d-none', (oldTotal == newTotal));
                        
                        booking.calc = [];
                        $("*[data-calc]").each(function (index) {
                            let item = JSON.parse($(this).attr('data-calc'));
                            item.inCalc = item.isOptional ? 0 : 1;
                            booking.calc.push(item);
                        });

                        $('.calc-item-row input[type="checkbox"]').change(function (e) {
                            let $row = $(this).closest('.calc-item-row');
                            let $quantity = $row.find('select.quantity');
                            let value = +$quantity.val();
                            let checked = $(this).is(':checked') ? 1 : 0;
            
                            if (checked && !value) {
                                $quantity.prop('value', 1);
                            } else if (!checked && value) {
                                $quantity.prop('value', 0);
                            }
            
                            booking.calculate($(this));
                        });
            
                        $('.calc-item-row select.quantity').change(function (e) {
                            let $row = $(this).closest('tr');
                            let $checkbox = $row.find('input[type="checkbox"]');
                            let value = +$(this).val();
            
                            if (value && !$checkbox.is(':checked')) {
                                $checkbox.prop('checked', true);
                            } else if (!value && $checkbox.is(':checked')) {
                                $checkbox.prop('checked', false);
                            }
            
                            booking.calculate($(this));
                        });

                        $('.allianz-row input[type="checkbox"]').change(function (e) {
                            let $checkbox = $(this).find('input[type="checkbox"]');
            
                            if ($checkbox.is(':checked')) $checkbox.prop('checked', true);
                            booking.calcAllianz();
                        });

                        $(".btn-promo-code").on('click', e => {
                            let params = {};
                            params['language'] = functions.getLang();
                            params['promoCode'] = $("input[name='promoCode']").val();
            
                            $.post('/services/promoCode/', params).then(response => {
                                response = JSON.parse(response);
            
                                $(".promo-code-output").removeClass('d-none').html(response.data);
                                if (response.status == true) {
                                    $(".btn-promo-code").attr('disabled', true);
                                    booking.applyDiscount(response);
                                }
                            });
                        });

                        booking.total();
                    }
                    
                });

                // details.params.guests = $target.val();
                // functions.setUrlData(details.params, true, true);
            });

            if(booking.$form.length)
            {
                let trackingData = JSON.parse($('[data-gatracking]').attr('data-gatracking'));

                if (trackingData) 
                {
                    trackingData['ecommerce']['value'] = booking.totalAmount;
                    trackingData['ecommerce']['payment_type'] = booking.params.paymentType;
                    trackingData['ecommerce']['items'][0]['quantity'] = 1;
                    trackingData['ecommerce']['items'][0]['price'] = booking.totalAmount;
                    functions.pushTrackingData(trackingData);
                }
            }

            booking.$form.on('submit', e => {
               booking.submit();

               $('html, body').stop().animate({
                    scrollTop: $('#booking-form').offset().top
                }, 0);
            });

        },
        submit() {
            
            $.each(booking.calc, function(key, item) {
                if ( ! item || ! item.inCalc) {
                    delete booking.calc[key];
                } else if (item.itemDefinitionId.categoryId.key == 'baseRate') {
                    let $guestsPerProduct = $("[data-guests-parentId='" + item.parentId + "']");
                    let guests = [];

                    if ($guestsPerProduct.length) {
                        $guestsPerProduct.find('[data-guests]').each(function (index) {
                            let g = +$(this).data('guests');
                            guests[index] = {
                                firstName : $(this).find("input[name='firstName" + g + "']").val(),
                                lastName : $(this).find("input[name='lastName" + g + "']").val(),
                                age : $(this).find("input[name='age" + g + "']").val()
                            };
                        });
                        booking.calc[key].guestsData = guests;
                    }
                }
            });
            booking.params.calc = JSON.stringify(booking.calc);
            booking.params.requestId = Math.floor(Math.random() * ((9999999 - 1000000) + 1) + 1000000);
            
            $.each(booking.params, function (key, param) {
                $('<input>').attr({
                    type: 'hidden',
                    name: key,
                    value: param
                }).appendTo(booking.$form);
            });

        },
        calcAllianz()
        {
            let $row = $('.allianz-row');
            if (! $row.length) return;

            let allianzItem = JSON.parse($row.attr('data-calc'));
            let $checkbox = $row.find('input[type="checkbox"]');
            let checked = 0;
            let id = null;
            let quantity = null;

            if ($checkbox.length) {
                checked = $checkbox.is(':checked') ? 1 : 0;
                id = $checkbox.attr('id');
            } 

            $.each(booking.calc, function (key, calc) {
                if (calc.id == id) {

                    if (quantity == null) {
                        quantity = booking.calc[key].quantity;
                    }

                    booking.calc[key].inCalc = 0;
                    booking.calc[key].quantity = (quantity || 1);
                    booking.calc[key].total = booking.totalAmount * 0.045;
                    booking.calc[key].priceIn = booking.calc[key].totalIn = booking.calc[key].price = booking.calc[key].total;
                    
                    if (checked) booking.params.allianzItem = JSON.stringify(booking.calc[key]);
                    else booking.params.allianzItem = null;
                    

                    if ($row) {
                        $row.find('.item-total-amount').html(functions.formatMoney(booking.calc[key].total, 2, ',', '.'));
                    }
                }
            });

        },
        calculate($elem) {
            let $row = $elem.closest('.calc-item-row');

            let $checkbox = $row.find('input[type="checkbox"]');
            let $quantity = $row.find('select.quantity');
            let checked = 0;
            let id = null;
            let quantity = null;

            if ($checkbox.length) {
                checked = $checkbox.is(':checked') ? 1 : 0;
                id = $checkbox.attr('id');
            } else if ($quantity.length) {
                checked = +$quantity.val();
                id = $quantity.attr('id');
            }

            if ($quantity.length) {
                quantity = +$quantity.val();
            }

            $.each(booking.calc, function (key, calc) {
                if (calc.id == id) {

                    if (quantity == null) {
                        quantity = booking.calc[key].quantity;
                    }

                    booking.calc[key].inCalc = checked;
                    booking.calc[key].quantity = (quantity || 1);
                    booking.calc[key].total = booking.itemTotal(booking.calc[key]);

                    if ($row) {
                        $row.find('.item-total-amount').html(functions.formatMoney(booking.calc[key].total, 2, ',', '.'));
                    }
                }
            });


            booking.total();
        },
        itemTotal(item) {
            let itemTotal = 0.00;

            if (item.paymentTypeId.key) {

                if ($.inArray(item.paymentTypeId.key, ['perPerson', 'perPersonPerDay', 'perPersonPerWeek']) > -1) {
                    itemTotal = +item.quantity * +item.price;
                } else {
                    itemTotal = +item.price;
                }
            } else {
                itemTotal = +item.quantity * +item.price;
            }

            return itemTotal;
        },
        total() {
            booking.totalAmount = 0.00;

            $.each(booking.calc, function (key, calc) {
                if (!calc.onSpot && calc.inCalc && calc.itemDefinitionId.objectGroupId.id != 11) {
                    booking.totalAmount += booking.itemTotal(calc);
                }
            });

            booking.$calculation.find('.total-amount').html(functions.formatMoney(booking.totalAmount, 2, ',', '.'));
            $('.total-amount').html(functions.formatMoney(booking.totalAmount, 2, ',', '.'));

            const advancePaymentPercent = $('.advance-percent').attr('data-advancepaymentpercent') || 100;
            const advance = booking.totalAmount * (advancePaymentPercent / 100);
            const rest = booking.totalAmount - advance;

            $('.advance').html(functions.formatMoney(advance, 2, ',', '.'));
            $('.rest').html(functions.formatMoney(rest, 2, ',', '.'));

            booking.calcAllianz();

        },
        setLoadingMode()
        {
            $('.loader-parent').prepend(tplLoader);
        },

        unsetLoadingMode()
        {
            $('.loader-parent').find('.list-loader').remove();
        },

        applyDiscount(promoCode) {
            booking.$calculation.each(function (index) {
                $(this).find(".promoDiscountItem").remove();
                let promoDiscountItem = JSON.parse($(this).find("*[data-calc]:first").attr('data-calc'));
                let promoDiscountItemId = promoDiscountItem.id + '_' + 114;

                let total = 0;
                let totalConverted = 0;
                $(this).find("*[data-calc]").each(function (index) {
                    let item = JSON.parse($(this).attr('data-calc'));
                    let quantity = item.isOptional ? $(this).find('select.quantity').val() : item.quantity;
                    if ( ! item.onSpot && quantity) {
                        total += +item.price * +quantity;
                        totalConverted += +item.priceConverted * +quantity;
                    }
                });

                $.each(booking.calc, function (key, calc) {
                    if (calc && calc.id == promoDiscountItemId) {
                        booking.calc.splice(key, 1);
                    }
                });

                let discountAmount = (-1 * (total * (promoCode.percent/100)));
                let discountAmountConverted = (-1 * (totalConverted * (promoCode.percent/100)));

                promoDiscountItem.id = promoDiscountItemId;
                promoDiscountItem.itemDefinitionId.id = 114;
                promoDiscountItem.itemDefinitionId.text = 'Promo Code Discount';
                promoDiscountItem.itemTitle = {
                    name_hr:'Promo Code Discount',
                };

               
                promoDiscountItem.itemDefinitionId.categoryId.id = 80;
                promoDiscountItem.itemDefinitionId.categoryId.key = 'discount';
                promoDiscountItem.itemDefinitionId.objectGroupId.id = 1;
                promoDiscountItem.itemDefinitionId.objectGroupId.key = 'accommodation';
                promoDiscountItem.itemDefinitionId.typeId.id = 3;
                promoDiscountItem.itemDefinitionId.typeId.key = 'discount';
                promoDiscountItem.priceIn = discountAmount;
                promoDiscountItem.price = discountAmount;
                promoDiscountItem.totalIn = discountAmount;
                promoDiscountItem.total = discountAmount;
                promoDiscountItem.priceConverted = discountAmountConverted;
                promoDiscountItem.skipCalculate = true;


                $('.table-calculation').find('tbody').append('<tr class="promoDiscountItem calc-item-row" data-calc=\'' + JSON.stringify(promoDiscountItem) + '\'>\n' +
                '        <td class="px-4 py-2 fw-bold">\n' +
                '            <span class="custom-control custom-checkbox">\n' +
                '                <input type="checkbox" class="custom-control-input" id="' + promoDiscountItem.id + '" name="' + promoDiscountItem.id + '" checked="" disabled="">\n' +
                '            </span>\n' +
                '            <span>'+ promoDiscountItem.itemDefinitionId.text +'</label>\n' +
                '        </td>\n' +
                '        <td class="px-lg-4 py-2 fw-bold text-center text-nowrap d-non d-lg-table-cell"> ' +
                '        </td>' +
                '        <td class="ps-4 py-2 fw-bold text-end text-nowrap">\n' +
                '          €<span class="item-total-amount">' + functions.formatMoney(discountAmount, 2, ',', '.') + '</span>\n' +
                '        </td>\n' +
                '    </tr>')

                booking.calc.push(promoDiscountItem);
                booking.calculate($(this).find(".promoDiscountItem"));
            });

        },
    }

    

    booking.init();
});